import { AutogenLayoutSalespersonCommissionReport } from "./autogen/AutogenLayoutSalespersonCommissionReport";

export class SalespersonCommissionReport extends AutogenLayoutSalespersonCommissionReport {
    onLoad() {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
    }
}
